/**
 * Desktop-only Product Gallery Navigation
 * This script only runs on devices with hover capability (desktop)
 */
document.addEventListener('DOMContentLoaded', function() {
  // Only run this code on desktop devices with hover capability
  if (window.matchMedia('(hover: hover)').matches) {
    setupDesktopProductGallery();
  }
});

function setupDesktopProductGallery() {
  // Find the product gallery with stack class
  const productGallery = document.querySelector('.Product__Gallery--stack');
  if (!productGallery) return;
  
  // Find the slideshow and slide items
  const slideshow = productGallery.querySelector('.Product__Slideshow');
  if (!slideshow) return;
  
  const slideItems = slideshow.querySelectorAll('.Product__SlideItem');
  if (slideItems.length <= 1) return; // No need for navigation with only one image
  
  // Find or create the navigation dots container
  let dotsContainer = productGallery.querySelector('.Product__SlideshowNav--dots');
  if (!dotsContainer) {
    dotsContainer = document.createElement('div');
    dotsContainer.className = 'Product__SlideshowNav Product__SlideshowNav--dots';
    productGallery.insertBefore(dotsContainer, slideshow);
  } else {
    // Clear existing dots
    dotsContainer.innerHTML = '';
  }
  
  // Create dots for each slide
  slideItems.forEach((slideItem, index) => {
    const dot = document.createElement('button');
    dot.className = 'dot';
    dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
    
    // Mark the first dot as selected
    if (index === 0) {
      dot.classList.add('is-selected');
    }
    
    // Add click event to scroll to the corresponding slide
    dot.addEventListener('click', function() {
      // Remove selected class from all dots
      dotsContainer.querySelectorAll('.dot').forEach(d => d.classList.remove('is-selected'));
      // Add selected class to clicked dot
      this.classList.add('is-selected');
      
      // Scroll to the corresponding slide
      slideItems[index].scrollIntoView({ behavior: 'smooth' });
    });
    
    dotsContainer.appendChild(dot);
  });
  
  // Set up intersection observer to update active dot when scrolling
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = Array.from(slideItems).indexOf(entry.target);
        const dots = dotsContainer.querySelectorAll('.dot');
        
        dots.forEach((dot, i) => {
          if (i === index) {
            dot.classList.add('is-selected');
          } else {
            dot.classList.remove('is-selected');
          }
        });
      }
    });
  }, { threshold: 0.5 });
  
  // Observe each slide item
  slideItems.forEach(slideItem => {
    observer.observe(slideItem);
  });
} 